import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contenedor-ciclos',
    templateUrl: './contenedor-ciclos.component.html',
    styleUrls: ['./contenedor-ciclos.component.scss'],
    standalone: false
})
export class ContenedorCiclosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
